import React from "react";
import type { IconProps } from "./type";
import { COLORS } from "@/app/common/consts/colors";

const CancelLine = ({ color = "gray" }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M4.6967 4.6967C3.33947 6.05393 2.5 7.92893 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5C12.0711 17.5 13.9461 16.6605 15.3033 15.3033M4.6967 4.6967C6.05393 3.33947 7.92893 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10C17.5 12.0711 16.6605 13.9461 15.3033 15.3033M4.6967 4.6967L10 10L15.3033 15.3033"
        stroke={COLORS[color]}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CancelLine;
